import { createFileRoute } from "@tanstack/react-router";
import { MeteoEmergencyPage } from "@/components/meteo-emergency-page";

export const Route = createFileRoute("/emergency")({
  head: () => ({
    meta: [
      { title: "Emergency Contacts & Flood Safety | Kenya | Meteo" },
      {
        name: "description",
        content:
          "Kenyan emergency helplines for flood, fire, police and disaster response. Plus flood safety tips from Meteo — real-time flood alerts for Kenya.",
      },
      { name: "robots", content: "index, follow" },
      {
        tagName: "link",
        rel: "canonical",
        href: "https://meteo.co.ke/emergency",
      },
      {
        property: "og:title",
        content: "Emergency Contacts & Flood Safety | Kenya | Meteo",
      },
      {
        property: "og:description",
        content:
          "Kenyan emergency helplines for flood, fire, police and disaster response. Plus flood safety tips from Meteo.",
      },
      { property: "og:url", content: "https://meteo.co.ke/emergency" },
      { property: "og:type", content: "website" },
    ],
  }),
  component: MeteoEmergencyPage,
});
